import { useContext } from 'react';

import { SnackbarContext } from '../components/Snackbar/SnackbarManager';

const useSnackbar = () => {
  const setMessage = useContext(SnackbarContext);

  return setMessage;
};

export default useSnackbar;
